import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { BankOpeningBalancesDetail } from "src/components/Pages/Documents/BankOpeningBalances/components/BankOpeningBalancesDetail";
import { NFLookupBankOpeningBalances } from "src/components/Shared/NewForms/NFLookupBankOpeningBalances";
import { BankOpeningBalancesDto } from "src/components/Pages/Documents/BankOpeningBalances/dtos/BankOpeningBalancesDto";
import BankOpeningBalancesList from "src/components/Pages/Documents/BankOpeningBalances/components/BankOpeningBalancesList";
import { BankOpeningBalancesService } from "src/services/documents/BankOpeningBalancesService";

export const BankOpeningBalances: IAppEntity = {
  entityType: "document",
  title: "Bank Opening Balances",
  pluralTitle: "Bank Opening Balances",
  apiUrl: "BankOpeningBalances",
  apiEnum: ReferenceTypes.DocumentBankOpeningBalance,
  getDetailView: (id?: string) => {
    return React.createElement(BankOpeningBalancesDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(BankOpeningBalancesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupBankOpeningBalances, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new BankOpeningBalancesService("BankOpeningBalances"),
  getEmptyModel: () => {
    const model: BankOpeningBalancesDto = {
      documentDate: new Date(),
            createdDate:new Date(),
            lines: [],
    };
    return model;
  }
};